import { IFramework, IWebServiceManager, HttpMethod, IUserContext } from "@truckdown/framework";
import { INoteManager } from "./INoteManager";
import { AddOrEditNoteModel } from "./Models/AddOrEditNoteModel";
import { ListingNote } from "./Models/ListingNote";
import { ResultModel } from "./Models/ResultModel";

class NoteManager implements INoteManager {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;
    private readonly basePath: string = '/locations';

    addOrUpdate(model: AddOrEditNoteModel): Promise<ListingNote | null> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/note-add',
            method: HttpMethod.POST
        }, model);

        return this.manager
            .send(req)
            .then((res) => {
                if (res.ok) {
                    return res.json()
                        .then((j) => {
                            return j as ListingNote;
                        });
                }

                if (res.status == 404) {
                    return null;
                }

                console.log("Error adding note ", res);
                return null;
            });
    }

    deleteNote(noteId: string): Promise<boolean> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/note-delete/' + encodeURIComponent(noteId),
            method: HttpMethod.DELETE
        });

        return this.manager
            .send(req)
            .then((res) => {
                if (res.ok) {
                    return res.json()
                        .then((j) => {
                            return (j as ResultModel<boolean>).results;
                        });
                }

                if (res.status == 404) {
                    return false;
                }

                console.log("Error deleting note " + noteId, res);
                return false;
            });
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<INoteManager>('INoteManager', (frm) => {
        return new NoteManager(frm);
    });
}
